<template>
  <main class="aa-type-of-paper">
    <v-container>
      <v-row
        class="fill-height ma-0"
        align="center"
        justify="center"
        v-if="initialLoading"
      >
        <v-progress-circular indeterminate color="red" :size="100" :width="10"
          >Loading</v-progress-circular
        >
      </v-row>

      <v-flex
        v-if="!preset && !initialLoading"
        class="aa-type-of-paper__heading"
      >
        <div class="preview-image-preset-wrap">
          <div class="preview-image-preset-inner-wrap">
          <v-img
              :src="this.previewImagePreset"
              :lazy-src="'/images/placehold.webp'"
              :height="auto"
              cover
              class="preview-image-preset-img"
          >
            <template v-slot:placeholder>
              <v-row
                  class="fill-height"
                  color="red"
                  align="center"
                  justify="center"
              >
                <v-progress-circular
                    indeterminate
                    color="red"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          </div>
        </div>
        <div class="preview-image-preset-title">
          <div class="original-image-preset">
            <a :href="this.originalImagePreset" target="_blank">Original Quality</a>
          </div>
          <h3 v-if="image && image.name">
            {{ image.name }}
          </h3>
          <div v-if="image && image.artist_name">
            by <router-link
              class="preview-image-preset-artist-link"
              :to="{
                name: 'artist',
                params: { artist: slugFormat(image.artist_name) },
              }"
          >
          <span v-if="image && image.artist_name">{{ image.artist_name }}</span>
          </router-link>
          </div>
        </div>
        <h1>Select a Product</h1>
        <p>
          Select a preset product from below to get started. You can configure
          anything you want after selecting, or start with with Custom preset to
          start from scratch.
        </p>
      </v-flex>

      <div class="aa-type-of-paper__gallery" v-if="!preset && !initialLoading">
        <div
          class="aa-type-of-paper__gallery-item"
          v-for="preset in presets"
          :key="preset.name"
        >
          <v-img
            :src="preset.previewImage"
            :lazy-src="preset.previewImage"
            aspect-ratio="1.3"
            @click="selectPreset(preset)"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="red"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <h4 @click="selectPreset(preset)">{{ preset.name }}</h4>
        </div>
      </div>
      <div class="aa-type-of-paper__single" v-show="preset">
        <div class="aa-type-of-paper__single-wrap">
          <div
            class="aa-type-of-paper__single-calculator"
            v-show="$route.query.mode === 'calculator'"
          >
            <div v-for="item in subItems" :key="item.product">
              <div class="aa-type-of-paper__single-calculator-heading">
                <h2>{{ item.product }}</h2>
                <p>{{ item.description }}</p>
              </div>

              <div>
                <h4>Price Per</h4>
                <span>
                  {{ item.totalPer | currency }}
                </span>
              </div>

              <div v-if="item.discountTotal">
                <h3>Product Total</h3>
                <span>{{ item.productTotal | currency }}</span>
              </div>

              <!-- <div v-if="item.discountTotal && this.pricing">
                <h3>Discount ({{ this.pricing.wholesaleDiscount * 100 }}%)</h3>
                <span>-{{ item.discountTotal | currency }}</span>
              </div> -->

              <div>
                <h3>Total</h3>
                <span>{{ item.total | currency }}</span>
              </div>
            </div>
          </div>
          <div
            class="aa-type-of-paper__single-media"
            v-show="$route.query.mode !== 'calculator'"
          >
            <div class="aa-type-of-paper__single-media-carousel">
              <v-carousel
                hide-delimiters
                height="auto"
                class="carousel"
                v-model="previewCarousel"
                :show-arrows="false"
              >
                <v-carousel-item>
                  <div
                    @mousemove="canvasMouseMove"
                    @click="canvasClick"
                    :class="{
                      'art-container': true,
                      'eyedropper-active': eyedropperActive,
                    }"
                  >
                    <canvas
                      ref="imageCanvas"
                      :width="canvasWidth"
                      :height="canvasHeight"
                    ></canvas>
                  </div>
                </v-carousel-item>
                <v-carousel-item
                  v-for="item in previewImages"
                  :key="item.src"
                  :src="item.src"
                >
                  <v-container fill-height fluid pa-0 ma-0 pb-0>
                    <v-layout fill-height align-end pb-0 mb-0>
                      <v-flex xs12>
                        <v-card class="pa-2 slide-text-container">
                          <div
                            class="white--text text-center"
                            v-text="item.description"
                          ></div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-carousel-item>
                <v-carousel-item v-for="item in previewVideos" :key="item.src">
                  <v-container fill-height fluid pa-0 ma-0 pb-0>
                    <v-layout fill-height align-end pb-0 mb-0>
                      <video preload autoplay loop class="preview-video">
                        <source :src="item.src" type="video/mp4" />
                      </video>
                      <v-card class="pa-2 video-text-container">
                        <div
                          class="white--text text-center"
                          v-text="item.description"
                        ></div>
                      </v-card>
                    </v-layout>
                  </v-container>
                </v-carousel-item>
              </v-carousel>
            </div>
            <v-alert
              v-if="previewCarousel === 0 && previewImages.length > 0"
              dense
              outlined
              class="aa-mark"
            >
              You can view product images by clicking the thumbnails below.
            </v-alert>
            <v-alert
              v-if="previewCarousel !== 0 && previewImages.length > 0"
              dense
              outlined
              class="aa-mark"
            >
              <v-layout justify-space-between align-center>
                You can return to your preview by clicking this button.

                <v-btn class="btn btn-primary" @click="returnToPreview"
                  >View Preview
                </v-btn>
              </v-layout>
            </v-alert>
            <v-alert v-if="eyedropperActive" dense outlined class="aa-mark">
              Wrap color select mode is active. Click on the image preview again
              to lock the currently selected color.
            </v-alert>
            <div class="carousel-thumbnail-container">
              <div
                v-for="(item, index) in previewImages"
                :key="item.src"
                @click="previewCarousel = index + 1"
              >
                <v-img
                  :src="item.src"
                  :height="150"
                  width="100%"
                  cover
                  class="carousel-thumbnail"
                />
              </div>

              <div
                v-for="(item, index) in previewVideos"
                :key="item.src"
                @click="previewCarousel = previewImages.length + index + 1"
              >
                <video
                  preload
                  :height="150"
                  autoplay
                  loop
                  class="preview-video"
                >
                  <source :src="item.src" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>

          <div class="aa-type-of-paper__single-card">
            <div class="aa-type-of-paper__single-card-sticky">
              <h1 v-if="image && image.name">
                {{ image.name }}
              </h1>
              <h1 v-else>Untitled</h1>

              <div
                class="aa-type-of-paper__single-card-artist"
                v-if="image && image.artist_slug"
              >
                by
                <router-link
                  target="_blank"
                  :to="{
                    name: 'artist',
                    params: { artist: image.artist_slug },
                  }"
                  >{{ image.artist_name }}</router-link
                >
              </div>
              <div class="aa-type-of-paper__single-card-wrap">
                <v-card flat>
                  <div class="aa-type-of-paper__single-card-size">
                    <h4>Size</h4>
                    <v-select
                      :items="printSizes"
                      :class="sizeNone ? 'error' : ''"
                      return-object
                      v-model="size"
                      :rules="validationRules.size"
                      solo
                      flat
                      hide-details="auto"
                    >
                    </v-select>
                    <div class="v-messages theme--light error--text" role="alert" v-if="this.sizeNone">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">
                          This field is required.
                        </div>
                      </div>
                    </div>
                    <span
                      class="aa-mark"
                      v-if="(matOn && matSize) || (frameOn && frame)"
                    >
                      {{
                        "Total Inside Frame Size " +
                          innerFrameWidth +
                          "x" +
                          innerFrameHeight +
                          "in"
                      }}
                    </span>
                    <div
                      class="aa-type-of-paper__single-card-size-custom"
                      v-if="size && size.value === 'custom'"
                    >
                      <h5>Width</h5>
                      <v-text-field
                        type="number"
                        label="Width"
                        suffix="in"
                        v-model.number="printWidth"
                        :rules="validationRules.printWidth"
                        solo
                        flat
                        hide-details="auto"
                        hide-spin-buttons
                      />

                      <h5>Height</h5>
                      <v-text-field
                        type="number"
                        label="Height"
                        suffix="in"
                        v-model.number="printHeight"
                        solo
                        flat
                        hide-details="auto"
                        :rules="validationRules.printHeight"
                        hide-spin-buttons
                      />
                    </div>
                  </div>
                  <div class="aa-type-of-paper__single-card-media">
                    <h4>Media</h4>
                    <v-select
                      v-model="media"
                      :items="medias"
                      return-object
                      solo
                      flat
                      hide-details="auto"
                    >
                    </v-select>
                  </div>
                </v-card>

                <v-card flat>
                  <div class="aa-type-of-paper__single-card-mounting">
                    <h4
                      :class="{
                        disabled: !(
                          showOptionsCard &&
                          options &&
                          options.mountingsAndStretchers
                        ),
                      }"
                    >
                      Mounting Options
                    </h4>
                    <div class="aa-type-of-paper__single-card-mounting-wrap">
                      <v-select
                        v-model="mountingOrStretcher"
                        :items="options.mountingsAndStretchers"
                        return-object
                        :label="mountingOrStretcherLabel"
                        solo
                        flat
                        hide-details="auto"
                        :disabled="
                          !(
                            showOptionsCard &&
                            options &&
                            options.mountingsAndStretchers
                          )
                        "
                      >
                      </v-select>

                      <!-- <v-btn-toggle
                      v-if="options && options.varnish"
                      v-model="varnish"
                      mandatory
                    >
                      <v-btn v-for="v in varnishes" :key="v.value" :value="v">
                        {{ v.text }}
                      </v-btn>
                    </v-btn-toggle> -->

                      <v-radio-group
                        v-if="options && options.varnish"
                        v-model="varnish"
                        column
                        hide-details="auto"
                        mandatory
                      >
                        <v-radio
                          color="red"
                          :ripple="false"
                          v-for="v in varnishes"
                          :label="v.text"
                          :key="v.value"
                          :value="v"
                        >
                        </v-radio>
                      </v-radio-group>

                      <div
                        class="aa-type-of-paper__single-card-finishing"
                        v-if="
                          options &&
                            options.mountingsAndStretchers &&
                            mountingOrStretcher &&
                            mountingOrStretcher.stretcher === true
                        "
                      >
                        <h4 class="font-weight-light">Finishing</h4>
                        <v-select
                          required
                          v-if="options && options.wraps && wrapRequired"
                          v-model="wrap"
                          :items="options.wraps"
                          label="Wrap"
                          return-object
                          :messages="formMessages.wrap"
                          :rules="validationRules.wrap"
                          solo
                          flat
                          hide-details="auto"
                        >
                        </v-select>
                        <div
                          class="color-picker-container"
                          v-if="wrap && wrap.value === 'color'"
                        >
                          <h4>Wrap Color</h4>
                          <v-alert dense outlined class="aa-mark">
                            Select an auto-generated swatch below, enter a HEX
                            color, or click on the preview image to turn on
                            color select mode and select a color from the image.
                          </v-alert>
                          <div>
                            <div
                              v-if="wrapColor"
                              :style="{
                                width: '100%',
                                height: '50px',
                                background: wrapColor,
                                border: '1px solid rgba(0, 0, 0, 0.38)',
                                'border-radius': '10px',
                              }"
                            ></div>
                            <v-color-picker
                              dot-size="15"
                              mode="hexa"
                              hide-mode-switch
                              show-swatches
                              hide-sliders
                              hide-canvas
                              width="100%"
                              swatches-max-height="139"
                              :swatches="imageSwatches"
                              v-model="wrapColor"
                            >
                            </v-color-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="aa-type-of-paper__single-card-border">
                    <v-switch
                      class="switch"
                      :ripple="false"
                      inset
                      v-model="borderOn"
                      label="Border"
                      hide-details="auto"
                      :disabled="
                        !showOptionsCard ||
                          !(options && options.border && !borderHidden)
                      "
                    ></v-switch>

                    <v-text-field
                      :disabled="
                        !borderOn ||
                          !showOptionsCard ||
                          !(options && options.border && !borderHidden)
                      "
                      type="number"
                      label="Border Size"
                      min="1"
                      max="6"
                      v-model.number="border"
                      suffix="in"
                      :rules="validationRules.border"
                      solo
                      flat
                      hide-details="auto"
                      hint="Enter a number between 1 and 6 inches (Can include
                    decimals)."
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </v-card>

                <v-card flat v-if="options && options.deckling">
                  <div class="aa-type-of-paper__single-card-deckling">
                    <v-switch
                      class="switch"
                      v-model="deckling"
                      :ripple="false"
                      label="Torn edge"
                      :disabled="!showOptionsCard"
                      inset
                      solo
                      flat
                      hide-details="auto"
                    >
                    </v-switch>
                  </div>
                </v-card>

                <v-card flat>
                  <div class="aa-type-of-paper__single-card-mat">
                    <v-switch
                      class="switch"
                      v-model="matOn"
                      inset
                      :ripple="false"
                      label="Mat"
                      :disabled="!options.mat || !showOptionsCard"
                      hide-details="auto"
                    ></v-switch>
                    <v-input
                      class="swatch-input"
                      :disabled="!matOn"
                      hide-details="auto"
                    >
                      <div class="swatch-wrapper">
                        <mat-swatch
                          v-for="matOption in mats"
                          :key="matOption.name"
                          :mat="matOption"
                          :selectedMat="mat"
                          :flagMat="!matOn"
                          @selected-mat="selectMat"
                        />
                      </div>
                    </v-input>
                    <v-text-field
                      type="number"
                      label="Mat Size"
                      min="0"
                      max="6"
                      :rules="validationRules.matSize"
                      v-model.number="matSize"
                      suffix="in"
                      hint="Enter a number between 1 and 6 inches (Can include decimals)."
                      persistent-hint
                      :disabled="!matOn"
                      solo
                      flat
                      hide-spin-buttons
                    >
                    </v-text-field>
                  </div>
                  <div class="aa-type-of-paper__single-card-frame">
                    <div class="aa-type-of-paper__single-card-frame-switch">
                      <v-switch
                        class="switch"
                        :readonly="frameDisabled"
                        v-model="frameOn"
                        inset
                        hide-details="auto"
                        :ripple="false"
                        label="Frame"
                        :messages="formMessages.frame"
                        :disabled="!options.frame || !showOptionsCard"
                      ></v-switch>

                      <v-switch
                        class="switch"
                        label="Plexi"
                        :readonly="plexiRequired"
                        v-model="plexi"
                        inset
                        :ripple="false"
                        hide-details="auto"
                        :messages="formMessages.plexi"
                        :disabled="
                          !frameOn ||
                            !showOptionsCard ||
                            !(media && media.options.plexi)
                        "
                      ></v-switch>
                    </div>
                    <v-input
                      class="swatch-input"
                      messages="All frames are 1' wide"
                      :disabled="!frameOn"
                    >
                      <div class="swatch-wrapper">
                        <frame-swatch
                          v-for="frameOption in frames"
                          :key="frameOption.name"
                          :frame="frameOption"
                          :selectedFrame="frame"
                          @selected-frame="selectFrame"
                          :flagFrame="!frameOn"
                        />
                      </div>
                    </v-input>
                  </div>
                </v-card>

                <div flat class="aa-type-of-paper__single-card-quantity">
                  <h3>Quantity</h3>
                  <div class="aa-type-of-paper__single-card-quantity-wrap">
                    <div>
                      <div class="quantity-toggle">
                        <button @click="decrement()">&#45;</button>
                        <v-text-field
                          type="number"
                          hide-details
                          min="1"
                          max="99"
                          maxlength="2"
                          oninput="if(this.value < 1){this.value = 1}else if(this.value > 99){this.value = 99};"
                          v-model="quantity"
                          reverse
                          solo
                          flat
                          hide-spin-buttons
                        ></v-text-field>

                        <button @click="increment()">&#43;</button>
                      </div>
                      <span>{{ totalPrice | currency }}</span>
                      <span style="display: none">{{ totalPriceOld | currency }}</span>
                    </div>
                    <v-btn
                      :loading="loading"
                      @click="addToCart"
                      class="btn btn-primary arrow"
                      v-if="this.$route.query.mode === 'create'"
                    >
                      Add To Cart
                    </v-btn>

                    <v-btn
                      :loading="loading"
                      @click="addToCart"
                      class="btn btn-primary arrow"
                      v-if="this.$route.query.mode === 'edit'"
                    >
                      Update Cart Item
                    </v-btn>
                  </div>
                </div>

                <!-- <v-card
                  flat
                  v-if="
                    discountTotal ||
                      discountTotal ||
                      this.$route.query.mode === 'edit'
                  "
                >
                  <v-row v-if="discountTotal" align="center">
                    <v-col cols="7" class="text-right">
                      <h4 class="font-weight-light">Product Total</h4>
                    </v-col>
                    <v-col cols="5" class="text-h6 text-right">{{
                      productTotal | currency
                    }}</v-col>
                  </v-row>
                  <v-row v-if="discountTotal" align="center">
                    <v-col cols="7" class="text-right">
                      <h4 class="font-weight-light">
                        Discount ({{ this.pricing.wholesaleDiscount * 100 }}%)
                      </h4>
                    </v-col>
                    <v-col cols="5" class="text-h6 text-right"
                      >-{{ discountTotal | currency }}</v-col
                    >
                  </v-row>
                </v-card> -->
              </div>
            </div>
          </div>
        </div>

        <SimilarArts
          v-if="this.sliderCategory != null"
          :slides="this.sliderCategory"
        />
      </div>
    </v-container>
  </main>
</template>

<script>
import * as Vibrant from "node-vibrant";
// import { fabric } from 'fabric';
import FrameSwatch from "@/components/Form/FrameSwatch.vue";
import MatSwatch from "@/components/Form/MatSwatch.vue";
import color from "color";
// import Vue from 'vue';
import ImageService from "@/services/ImageService";
import CartService from "@/services/CartService";
import ConfigService from "@/services/ConfigService";
// import calculatorImageData from '../assets/image.js';

import SimilarArts from "@/components/Slider/SimilarArts";

import { mapGetters } from "vuex";

export default {
  name: "Order",
  components: { FrameSwatch, MatSwatch, SimilarArts },
  data: () => {
    return {
      sizeNone: false,
      sliderCategory: null,
      initialLoading: true,
      cart_item: null,
      image: null,
      presets: [],
      frames: [],
      medias: [],
      mountingsAndStretchers: [],
      wraps: [],
      varnishes: [],
      mats: [],
      pricing: [],
      printSizesLongEdge: [],
      canvasWidth: 500,
      canvasHeight: 500,
      printWidth: null,
      printHeight: null,
      canvasImage: null,
      canvas: null,
      eyedropperActive: false,
      eyedropperData: null,
      imagePallete: null,
      imageSwatches: [],
      preset: null,
      size: null,
      media: null,
      wrapColor: "#FFFFFF",
      deckling: null,
      varnish: null,
      stretcher: null,
      border: null,
      borderOn: false,
      wrap: null,
      frame: null,
      frameOn: false,
      mat: null,
      matSize: null,
      matOn: false,
      plexi: null,
      spacer: null,
      mounting: null,
      quantity: 1,
      mountingOrStretcher: null,
      previewCarousel: 0,
      previewColSize: 6,
    };
  },

  methods: {
    slugFormat(el) {
      return el.replace(/\s+/g, "_").toLowerCase();
    },
    increment() {
      if (this.quantity >= 99) {
        return false;
      }
      this.quantity++;
    },
    decrement() {
      if (this.quantity <= 1) {
        return false;
      } else {
        this.quantity--;
      }
    },
    calculateItemTotals: function(item) {

      item.productBaseTotal = 'productBaseTotal' in item ? item.productBaseTotal : item.productTotal;

      if (this.authUser && this.authUser.wholesale_discount) {
        item.discountTotal = this.round(
          item.productTotal * this.pricing.wholesaleDiscount
        );

        item.discountTotalOld = this.round(
            item.productBaseTotal * this.pricing.wholesaleDiscount
        );

      } else {
        item.discountTotal = 0;
        item.discountTotalOld = 0;
      }

      item.total =
        this.round(item.productTotal - item.discountTotal) * this.quantity;

      item.totalOld =
          this.round(item.productBaseTotal - item.discountTotalOld) * this.quantity;

      item.totalPer = this.round(item.productTotal - item.discountTotal);
      item.totalPerOld = this.round(item.productBaseTotal - item.discountTotalOld);

      return item;
    },
    roundImageDimension: function(num) {
      // get the remainder
      const remainder = num % 1;
      let newRemainder = remainder;
      const whole = Math.floor(num);
      let newWhole = whole;

      if (remainder <= 0.25) {
        newRemainder = 0;
      } else if (remainder > 0.25 && remainder < 0.7) {
        newRemainder = 0.5;
      } else if (remainder >= 0.7) {
        newRemainder = 0;
        newWhole++;
      }

      return newWhole + newRemainder;
    },
    round: function(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
    recalculateMarkup: function(value, name = '') {
      let old_value = value;
      let current_user = !!this.authUser && this.authUser.artist_id == this.image.artist_id;
      value = this.image.markup > 0 && !current_user ? value + (value * this.image.markup / 100) : value;
      console.log(value, 'Recalculate Markup in ' + name + ' ' + old_value + ' + (' + old_value + ' * ' + this.image.markup + ' / 100)');

      return value;
    },
    addToCart: async function() {
      let dataLength = 0;
      let dataProductTotal = 0;
      let dataProductTotalOld = 0;
      let dataGrandTotal = 0;
      let dataGrandTotalOld = 0;
      let dataDiscountTotal = 0;
      let dataDiscountTotalOld = 0;
      let cart_items = "";

      const data = {
        quantity: this.quantity,
        print_options: {
          border: this.border,
          wrap: this.wrap ? this.wrap.value : null,
          frame: this.frame ? this.frame.value : null,
          mat: this.mat ? this.mat.value : null,
          matSize: this.matSize,
          plexi: this.plexi,
          mountingOrStretcher: this.mountingOrStretcher
            ? this.mountingOrStretcher.value
            : null,
          varnish: this.varnish ? this.varnish.value : null,
          deckling: this.deckling,
          media: this.media ? this.media.value : null,
          preset: this.preset ? this.preset.value : null,
          printWidth: this.printWidth,
          printHeight: this.printHeight,
          products: this.subItems,
          markup: this.image.markup,
        },
        total: this.totalPrice,
        totalOld: this.totalPriceOld,
        item_total: this.pricePer,
        item_totalOld: this.pricePerOld,
        discount_total: this.discountTotal,
        discount_totalOld: this.discountTotal,
        product_total: this.productTotal,
        product_totalOld: this.productTotalOld,
        image_id: this.image.id,
      };

      if (this.size && this.size.value === "none") {
        this.sizeNone = true;
        return;
      }

      if (this.$route.query.mode === "create") {
        try {
          if (!this.authUser) {
            let localData = JSON.parse(
              localStorage.getItem("guestCart") || "[]"
            );

            if (localData.length !== 0) {
              cart_items = localData.cart_items;

              localData.cart_items.forEach(function(e) {
                dataLength += e.quantity;
                dataProductTotal += e.product_total;
                dataGrandTotal += e.total;
                dataDiscountTotal += e.discount_total;
              });
            }

            dataLength += this.quantity;
            data.image = this.image;
            data.image_id = this.image.id;
            data.id = Math.floor(Math.random() * 1000000000);
            data.local_id = Math.floor(Math.random() * 1000000000);

            const dataGuest = {
              cart_items: [...[data], ...cart_items],
              total_items: dataLength,
              product_total: (dataProductTotal += data.product_total),
              product_totalOld: (dataProductTotalOld += data.product_totalOld),
              grand_total: (dataGrandTotal += data.total),
              grand_totalOld: (dataGrandTotalOld += data.totalOld),
              discount_total: (dataDiscountTotal += data.discount_total),
              discount_totalOld: (dataDiscountTotalOld += data.discount_totalOld),
            };

            localStorage.setItem("guestCart", JSON.stringify(dataGuest));
            this.$eventHub.$emit("upDataCart", true);
          } else {
            const response = await CartService.addCartItem(data);
            console.log(response);
          }

          this.$store.dispatch("snackbar/showSnack", {
            text: "Item added to cart successfully.",
            color: "success",
            timeout: 2000,
          });
          this.$store.dispatch("cart/getCart");
        } catch (err) {
          console.error(err);
          this.$store.dispatch("snackbar/showSnack", {
            text:
              "There was an error adding item to cart. Please try again later.",
            color: "error",
            timeout: 3500,
          });
        }
      } else if (this.$route.query.mode === "edit") {
        const imageQueryId = this.$route.query.cart_item_id;

        if (!this.authUser) {
          let localData = JSON.parse(localStorage.getItem("guestCart") || "[]");
          let localItems = localData.cart_items;
          let allItems, currItem;

          allItems = localItems.filter(function(obj) {
            return obj.local_id !== imageQueryId;
          });

          data.image = this.image;
          data.image_id = this.image.id;
          data.id = Math.floor(Math.random() * 1000000000);
          data.local_id = Math.floor(Math.random() * 1000000000);

          currItem = [...[data], ...allItems];

          if (localData.length !== 0) {
            cart_items = localItems;

            currItem.forEach(function(e) {
              dataLength += e.quantity;
              dataProductTotal += e.product_total;
              dataGrandTotal += e.total;
              dataDiscountTotal += e.discount_total;
            });
          }

          const dataGuest = {
            cart_items: currItem,
            total_items: dataLength,
            product_total: dataProductTotal,
            grand_total: dataGrandTotal,
            discount_total: dataDiscountTotal,
          };

          localStorage.setItem("guestCart", JSON.stringify(dataGuest));
          this.$eventHub.$emit("upDataCart", true);
          this.$router.push({ path: "/checkout" });
        } else {
          try {
            const response = await CartService.updateCartItem(
              this.cart_item.id,
              data
            );
            console.log(response);
            this.$store.dispatch("cart/getCart");
            this.$store.dispatch("snackbar/showSnack", {
              text: "Cart item updated successfully.",
              color: "success",
              timeout: 2000,
            });
            this.$router.push("/checkout");
          } catch (err) {
            console.error(err);
            this.$store.dispatch("snackbar/showSnack", {
              text:
                "There was an error updating cart item. Please try again later.",
              color: "error",
              timeout: 3500,
            });
          }
        }
      }
    },
    returnToPreview: function() {
      console.log("returning to preview");
      this.previewCarousel = 0;
    },
    selectPreset: function(preset) {
      this.preset = preset;
      if (preset.config) {
        const config = preset.config;
        console.log("preset config", config);
        if (config.media) {
          this.media = this.medias.find((m) => m.value === config.media);
        }
        // setting the media resets all of the other values, so we need to wait
        // until the media has changed to make updates to the other fields
        // so we do this in a timeout to ensure all of the watchers have
        // completed and state has been changed before updating the rest
        // of the state values
        setTimeout(() => {
          if (config.size) {
            this.size = this.printSizes.find((s) => s.value === config.size);
          } else {
            console.log(this.printSizes[0]);
            this.size = this.printSizes[0];
          }
          if (config.frame) {
            this.frame = this.frames.find((f) => f.value === config.frame);
            this.frameOn = true;
          }

          if (config.mountingOrStretcher) {
            this.mountingOrStretcher = this.mountingsAndStretchers.find(
              (m) => m.value === config.mountingOrStretcher
            );
          }

          if (config.wrap) {
            setTimeout(() => {
              this.wrap = this.wraps.find((w) => w.value === config.wrap);
            }, 10);
          }

          if (config.mat) {
            this.mat = this.mats.find((m) => m.value === config.mat);
            this.matOn = true;
            if (config.matSize) {
              this.matSize = config.matSize;
            } else {
              this.matSize = 2;
            }
          }

          if (config.border) {
            this.border = config.border;
            this.borderOn = true;
          }

          if (config.varnish) {
            this.varnish = this.varnishes.find(
              (v) => v.value === config.varnish
            );
          }

          if (config.deckling) {
            this.deckling = config.deckling;
          }
        }, 10);
        // for (const [key, value] of Object.entries(preset.config)) {
        //     if (key === "frame") {

        //     }
        // }
      }
    },
    // if a value becomes unavailable because of the dynamic form changing
    // we want to make sure we reset that value
    resetUnavailableValues: function() {
      // check that the currently selected mounting or stretcher is available
      if (
        this.mountingOrStretcher &&
        this.options.mountingsAndStretchers &&
        !this.options.mountingsAndStretchers.find(
          (s) => s.value === this.mountingOrStretcher.value
        )
      ) {
        this.mountingOrStretcher = null;
      }

      // remove the wrap if we can't have one
      if (!this.wrapRequired) {
        this.wrap = null;
      }

      // check that the currently selected wrap is available
      if (
        this.wrap &&
        this.options.wraps &&
        !this.options.wraps.find((w) => w.value === this.wrap.value)
      ) {
        this.wrap = null;
      }

      // no borders with frames
      if (this.frameOn && this.frame) {
        this.border = null;
        this.borderOn = false;
      }

      if (!this.frameOn) {
        this.frame = null;
        this.plexi = null;
      }

      if (!this.matOn) {
        this.mat = null;
        this.matSize = null;
      }

      // if the wrap isn't there or isn't a color wrap, make sure the eyedropper
      // active is removed, in case someone changes something while in color
      // select mode
      if (!this.wrap || (this.wrap && this.wrap.value !== "color")) {
        this.eyedropperActive = false;
      }
    },
    getCanvasPixelsPerInch: function(width) {
      // convert inches to pixels
      return Math.floor(this.canvasWidth / width);
    },
    // TODO: needs to account for borders on all options
    getTotalDimension: function(dimension) {
      // starts with a dimension
      // if mat, add mat size
      // if border, add border size
      // if there is a mat, the border is automatically a 1/2 inch (configured elsewhere)
      // if frame won't affect the total dimensions except for the preview (may need to handle)


      if (this.mat && this.matSize) {
        dimension += this.matSize * 2;
      }

      if (this.borderOn && this.border) {
        dimension += this.border * 2;
      }

      // if (this.mat && this.matSize && !this.frame) {
      //   return dimension + this.matSize * 2;
      // }

      // if (this.frame && this.frame.width && !this.mat) {
      //   return dimension + this.frame.width * 2;
      // }

      // if (this.frame && this.frame.width && this.mat && this.matSize) {
      //   return dimension + this.frame.width * 2 + this.matSize * 2;
      // }

      // if (this.border) {
      //   return dimension + this.border * 2;
      // }

      return dimension;
    },
    getCanvasTotalDimension: function(dimension) {
      // starts with a dimension
      // if mat, add mat size
      // if border, add border size
      // if there is a mat, the border is automatically a 1/2 inch (configured elsewhere)
      // if frame won't affect the total dimensions except for the preview (may need to handle)

      if (this.mat && this.matSize) {
        dimension += this.matSize * 2;
      }

      if (this.borderOn && this.border) {
        dimension += this.border * 2;
      }

      if (this.mat && this.matSize && !this.frame) {
        return dimension + this.matSize * 2;
      }

      if (this.frame && this.frame.width && !this.mat) {
        return dimension + this.frame.width * 2;
      }

      if (this.frame && this.frame.width && this.mat && this.matSize) {
        return dimension + this.frame.width * 2 + this.matSize * 2;
      }

      if (this.border) {
        return dimension + this.border * 2;
      }

      return dimension;
    },
    drawImage: function(img, x, y, width, height, deg, flip, flop, center) {
      this.canvas.save();

      if (typeof width === "undefined") width = img.width;
      if (typeof height === "undefined") height = img.height;
      if (typeof center === "undefined") center = false;

      // Set rotation point to center of image, instead of top/left
      if (center) {
        x -= width / 2;
        y -= height / 2;
      }

      // Set the origin to the center of the image
      this.canvas.translate(x + width / 2, y + height / 2);

      // Rotate the canvas around the origin
      var rad = 2 * Math.PI - (deg * Math.PI) / 180;
      this.canvas.rotate(rad);

      let flipScale = 1;
      let flopScale = 1;

      // Flip/flop the canvas
      if (flip) flipScale = -1;
      if (flop) flopScale = -1;
      this.canvas.scale(flipScale, flopScale);

      // Draw the image
      this.canvas.drawImage(img, -width / 2, -height / 2, width, height);

      this.canvas.restore();
    },
    mirrorImage: function(
      image,
      x = 0,
      y = 0,
      width,
      height,
      horizontal = false,
      vertical = false
    ) {
      this.canvas.save(); // save the current canvas state
      this.canvas.setTransform(
        horizontal ? -1 : 1,
        0, // set the direction of x axis
        0,
        vertical ? -1 : 1, // set the direction of y axis
        x + (horizontal ? width : 0), // set the x origin
        y + (vertical ? height : 0) // set the y origin
      );
      this.canvas.drawImage(image, 0, 0, width, height);
      this.canvas.restore(); // restore the state as it was when this function was called
    },
    generateFrameCorners: function() {
      return new Promise((resolve) => {
        const frame = {};
        // determine what size the frame should be
        // render the four corners and the straights
        const size =
          this.frame.width * this.canvasPixelsPerInch +
          this.frame.width * this.canvasPixelsPerInch * 0.25;
        const cornerImage = new Image(size, size);
        cornerImage.src = this.frame.cornerImage;
        cornerImage.onload = () => {
          frame.frameTopLeftCorner = {
            image: cornerImage,
            locationX: 0,
            locationY: 0,
            width: size,
            height: size,
          };
          frame.frameTopRightCorner = {
            image: cornerImage,
            locationX: this.canvasWidth - size,
            locationY: 0,
            width: size,
            height: size,
          };
          frame.frameBottomLeftCorner = {
            image: cornerImage,
            locationX: 0,
            locationY: this.canvasHeight - size,
            width: size,
            height: size,
          };
          frame.frameBottomRightCorner = {
            image: cornerImage,
            locationX: this.canvasWidth - size,
            locationY: this.canvasHeight - size,
            width: size,
            height: size,
          };

          resolve(frame);
        };
      });
    },
    generateFrameStraights: function() {
      return new Promise((resolve) => {
        const size = this.frame.width * this.canvasPixelsPerInch;
        const straights = [];
        const straightImage = new Image(size, size);
        const numX = Math.ceil(this.canvasWidth / size);
        const numY = Math.ceil(this.canvasHeight / size);
        straightImage.src = this.frame.straightImage;
        straightImage.onload = () => {
          for (let x = 1; x <= numX; x++) {
            // top line
            straights.push({
              image: straightImage,
              locationX: size * x,
              locationY: 0,
              width: size,
              height: size,
            });

            // bottom line
            straights.push({
              image: straightImage,
              locationX: size * x,
              locationY: this.canvasHeight - size,
              width: size,
              height: size,
            });
          }

          for (let y = 1; y <= numY; y++) {
            // left line
            straights.push({
              image: straightImage,
              locationX: 0,
              locationY: size * y,
              width: size,
              height: size,
              rotate: 90,
            });

            // right line
            straights.push({
              image: straightImage,
              locationX: this.canvasWidth - size,
              locationY: size * y,
              width: size,
              height: size,
              rotate: 90,
            });
          }

          resolve(straights);
        };
      });
    },
    resetForm: function() {
      console.log("resetting values and form");
      this.matOn = false;
      this.mat = null;
      this.frameOn = false;
      this.frame = null;
      this.wrap = null;
      this.mountingOrStretcher = null;
      this.border = null;
      this.deckling = null;
      this.varnish = null;
    },
    recalculateCanvasSize: function(width, height) {
      this.canvasHeight = this.getCanvasPixelsPerInch(width) * height;

      const longEdge = width > height ? width : height;
      if (longEdge > 16) {
        this.plexi = true;
      }

      if (longEdge > 32) {
        this.frame = false;
        this.frameOn = false;
      }
    },
    renderCanvas: async function() {
      const elements = {};
      console.log(
        "render canvas",
        "width",
        this.canvasWidth,
        "height",
        this.canvasHeight,
        "pixelsPerInch",
        this.canvasPixelsPerInch
      );

      const hasBorder = this.border;
      const hasMat = this.mat;
      const hasFrame = this.frame;

      let startLocationX = 0;
      let startLocationY = 0;
      let endLocationX = this.canvasWidth;
      let endLocationY = this.canvasHeight;

      if (hasBorder) {
        const borderWidth = this.border * this.canvasPixelsPerInch;
        console.log("border width", borderWidth);
        startLocationX = borderWidth;
        startLocationY = borderWidth;
        endLocationX = this.canvasWidth - borderWidth * 2;
        endLocationY = this.canvasHeight - borderWidth * 2;

        elements.border = {
          lineWidth: borderWidth,
          strokeStyle: "#FFFFFF",
          startLocationY: 0 + borderWidth / 2,
          startLocationX: 0 + borderWidth / 2,
          endLocationY: this.$refs.imageCanvas.height - borderWidth,
          endLocationX: this.$refs.imageCanvas.width - borderWidth,
        };
      }

      if (hasFrame && !hasMat) {
        const frameWidth = this.frame.width * this.canvasPixelsPerInch;
        startLocationX = frameWidth;
        startLocationY = frameWidth;
        endLocationX = this.canvasWidth - frameWidth * 2;
        endLocationY = this.canvasHeight - frameWidth * 2;
      }

      if (hasMat && !hasFrame) {
        const matWidth = this.matSize * this.canvasPixelsPerInch;
        startLocationX = matWidth;
        startLocationY = matWidth;
        endLocationX = this.canvasWidth - matWidth * 2;
        endLocationY = this.canvasHeight - matWidth * 2;

        elements.mat = {
          lineWidth: matWidth,
          strokeStyle: this.mat.color,
          startLocationY: 0 + matWidth / 2,
          startLocationX: 0 + matWidth / 2,
          endLocationY: this.$refs.imageCanvas.height - matWidth,
          endLocationX: this.$refs.imageCanvas.width - matWidth,
        };
      }

      if (hasFrame && hasMat) {
        const frameWidth = this.frame.width * this.canvasPixelsPerInch;
        const matWidth = this.matSize * this.canvasPixelsPerInch;
        startLocationX = matWidth + frameWidth;
        startLocationY = matWidth + frameWidth;
        endLocationX = this.canvasWidth - matWidth * 2 - frameWidth * 2;
        endLocationY = this.canvasHeight - matWidth * 2 - frameWidth * 2;

        console.log(
          this.$refs.imageCanvas.height - frameWidth * 2,
          this.$refs.imageCanvas.width - frameWidth * 2
        );

        elements.mat = {
          lineWidth: matWidth,
          strokeStyle: this.mat.color,
          startLocationY: 0 + frameWidth + matWidth / 2,
          startLocationX: 0 + frameWidth + matWidth / 2,
          endLocationY:
            this.$refs.imageCanvas.height - frameWidth * 2 - matWidth,
          endLocationX:
            this.$refs.imageCanvas.width - frameWidth * 2 - matWidth,
        };
      }

      elements.background = {
        image: this.canvasImage,
        startLocationX: startLocationX,
        startLocationY: startLocationY,
        endLocationX: endLocationX,
        endLocationY: endLocationY,
      };

      this.canvas.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

      if (elements.background) {
        this.canvas.drawImage(
          elements.background.image,
          elements.background.startLocationX,
          elements.background.startLocationY,
          elements.background.endLocationX,
          elements.background.endLocationY
        );
      }

      if (elements.border) {
        this.canvas.beginPath();
        this.canvas.lineWidth = elements.border.lineWidth;
        this.canvas.strokeStyle = elements.border.strokeStyle;
        this.canvas.rect(
          elements.border.startLocationX,
          elements.border.startLocationY,
          elements.border.endLocationX,
          elements.border.endLocationY
        );
        this.canvas.stroke();
      }

      if (elements.mat) {
        this.canvas.beginPath();
        this.canvas.lineWidth = elements.mat.lineWidth;
        this.canvas.strokeStyle = elements.mat.strokeStyle;
        this.canvas.rect(
          elements.mat.startLocationX,
          elements.mat.startLocationY,
          elements.mat.endLocationX,
          elements.mat.endLocationY
        );
        this.canvas.stroke();
      }

      if (hasFrame) {
        // do something
        const frameCorners = await this.generateFrameCorners();
        const frameStraights = await this.generateFrameStraights();

        for (let x = 0; x < frameStraights.length; x++) {
          const straight = frameStraights[x];
          this.canvas.translate(
            straight.locationX + straight.width / 2,
            straight.locationY + straight.height / 2
          );
          if (straight.rotate) {
            this.canvas.rotate((Math.PI / 180) * straight.rotate);
          }
          this.canvas.drawImage(
            straight.image,
            -straight.width / 2,
            -straight.height / 2,
            straight.width,
            straight.height
          );
          // reset back to the beginning
          this.canvas.setTransform(1, 0, 0, 1, 0, 0);
        }

        if (frameCorners.frameTopLeftCorner) {
          this.canvas.drawImage(
            frameCorners.frameTopLeftCorner.image,
            frameCorners.frameTopLeftCorner.locationX,
            frameCorners.frameTopLeftCorner.locationY,
            frameCorners.frameTopLeftCorner.width,
            frameCorners.frameTopLeftCorner.height
          );
        }

        if (frameCorners.frameTopRightCorner) {
          //   this.canvas.translate(
          //     frameCorners.frameTopRightCorner.locationX +
          //       frameCorners.frameTopRightCorner.width / 2,
          //     frameCorners.frameTopRightCorner.locationY +
          //       frameCorners.frameTopRightCorner.height / 2
          //   );
          //   this.canvas.rotate((Math.PI / 180) * 90);
          //   this.canvas.drawImage(
          //     frameCorners.frameTopRightCorner.image,
          //     -frameCorners.frameTopRightCorner.width / 2,
          //     -frameCorners.frameTopRightCorner.height / 2,
          //     frameCorners.frameTopRightCorner.width,
          //     frameCorners.frameTopRightCorner.height
          //   );
          //   // reset back to the beginning
          //   this.canvas.setTransform(1, 0, 0, 1, 0, 0);
          this.drawImage(
            frameCorners.frameTopRightCorner.image,
            frameCorners.frameTopRightCorner.locationX,
            frameCorners.frameTopRightCorner.locationY,
            frameCorners.frameTopRightCorner.width,
            frameCorners.frameTopRightCorner.height,
            0,
            true,
            false
          );
        }

        if (frameCorners.frameBottomLeftCorner) {
          //   this.canvas.translate(
          //     frameCorners.frameBottomLeftCorner.locationX +
          //       frameCorners.frameBottomLeftCorner.width / 2,
          //     frameCorners.frameBottomLeftCorner.locationY +
          //       frameCorners.frameBottomLeftCorner.height / 2
          //   );
          //   this.canvas.rotate((Math.PI / 180) * 270);
          //   this.canvas.drawImage(
          //     frameCorners.frameBottomLeftCorner.image,
          //     -frameCorners.frameBottomLeftCorner.width / 2,
          //     -frameCorners.frameBottomLeftCorner.height / 2,
          //     frameCorners.frameBottomLeftCorner.width,
          //     frameCorners.frameBottomLeftCorner.height
          //   );
          //   // reset back to the beginning
          //   this.canvas.setTransform(1, 0, 0, 1, 0, 0);
          this.drawImage(
            frameCorners.frameBottomLeftCorner.image,
            frameCorners.frameBottomLeftCorner.locationX,
            frameCorners.frameBottomLeftCorner.locationY,
            frameCorners.frameBottomLeftCorner.width,
            frameCorners.frameBottomLeftCorner.height,
            0,
            false,
            true
          );
        }

        if (frameCorners.frameBottomRightCorner) {
          //   this.canvas.translate(
          //     frameCorners.frameBottomRightCorner.locationX +
          //       frameCorners.frameBottomRightCorner.width / 2,
          //     frameCorners.frameBottomRightCorner.locationY +
          //       frameCorners.frameBottomRightCorner.height / 2
          //   );
          //   this.canvas.rotate((Math.PI / 180) * 180);
          //   this.canvas.drawImage(
          //     frameCorners.frameBottomRightCorner.image,
          //     -frameCorners.frameBottomRightCorner.width / 2,
          //     -frameCorners.frameBottomRightCorner.height / 2,
          //     frameCorners.frameBottomRightCorner.width,
          //     frameCorners.frameBottomRightCorner.height
          //   );
          //   // reset back to the beginning
          //   this.canvas.setTransform(1, 0, 0, 1, 0, 0);

          this.drawImage(
            frameCorners.frameBottomRightCorner.image,
            frameCorners.frameBottomRightCorner.locationX,
            frameCorners.frameBottomRightCorner.locationY,
            frameCorners.frameBottomRightCorner.width,
            frameCorners.frameBottomRightCorner.height,
            270,
            true,
            false
          );
        }
      }
    },
    mountingOrStretcherUpdated: function() {
      if (this.media === "Canvas") {
        this.border = "Border";
      }
    },
    updateFrame: function(frame) {
      this.frame = frame;
    },
    canvasMouseMove: function(e) {
      if (this.eyedropperActive) {
        this.getCanvasColorAtCoordinates(e.offsetX, e.offsetY);
      }
    },
    canvasClick: function() {
      if (!this.wrap || (this.wrap && this.wrap.value !== "color")) {
        return;
      }

      this.eyedropperActive = !this.eyedropperActive;
      if (this.eyedropperActive) {
        this.canvas.defaultCursor = "crosshair";
      } else {
        this.canvas.defaultCursor = "default";
      }
    },
    getCanvasColorAtCoordinates: function(x, y) {
      const ctx = this.$refs.imageCanvas.getContext("2d");

      const data = ctx.getImageData(x, y, 1, 1).data;
      const hexColor = color({ r: data[0], g: data[1], b: data[2] }).hex();
      this.wrapColor = hexColor;
    },
    selectFrame: function(frame) {
      this.frame = frame;
    },
    selectMat: function(mat) {
      this.mat = mat;
    },
  },
  watch: {
    varnish: function(value) {
      console.log("varnish watcher", value);
    },
    options: {
      handler(options) {
        console.log("options watcher", options);
        // if the options change, we want to make sure we reset anything that
        // we're not allowed to have anymore
        if (!options.frame) {
          this.frameOn = false;
          this.frame = null;
        }

        if (!options.mountingsAndStretchers) {
          this.mountingOrStretcher = null;
        }

        if (!options.deckling) {
          this.deckling = false;
        }

        if (!options.varnish) {
          this.varnish = null;
        }

        if (!options.wraps) {
          this.wrap = null;
        }

        if (!options.mat) {
          this.matOn = false;
          this.mat = null;
        }

        if (!options.plexi) {
          this.plexi = false;
        }

        if (!options.border) {
          this.borderOn = false;
          this.border = null;
        }
      },
      deep: true,
    },
    media: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("media watcher", value);
      if (!value) {
        return;
      }

      if (value && value.value === "canvas") {
        this.varnish = this.varnishes.find((v) => v.value === "varnish");
      } else if (value && value.value !== "canvas") {
        this.varnish = null;
      }

      setTimeout(() => {
        this.renderCanvas();
      }, 10);

      // if the media is changed, we're going to reset all the stuff
      this.resetForm();
    },
    border: function() {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      setTimeout(() => {
        console.log("border watcher");
        this.renderCanvas();
      }, 10);
    },
    borderOn: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("borderOn watcher", value);
      // if the user turns off the frame, remove the selected frame
      if (!value || value === false) {
        this.border = null;
      }
    },
    frame: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("frame watcher", value);
      setTimeout(() => {
        this.renderCanvas();
      }, 10);

      this.resetUnavailableValues();

      if (!value) {
        return;
      }

      const hasUnavailableStretcher =
        this.mountingOrStretcher !== null &&
        !this.options.mountingsAndStretchers.some(
          (m) => m.value === this.mountingOrStretcher.value
        );

      // if the user didn't select a mounting or stretcher and selected a frame
      // it needs to be on a 1" stretcher
      if (
        this.mountingOrStretcherRequired &&
        (!this.mountingOrStretcher || hasUnavailableStretcher)
      ) {
        this.mountingOrStretcher = this.mountingsAndStretchers.find(
          (m) => m.value === "mdf"
        );
        return;
      }

      // if the user has a stretcher selected, we need to set the wrap to white
      // and set the stretcher to a 1" stretcher
      if (
        this.mountingOrStretcherRequired &&
        this.mountingOrStretcher &&
        this.mountingOrStretcher.stretcher === true
      ) {
        this.mountingOrStretcher = this.mountingsAndStretchers.find(
          (m) => m.value === "one"
        );
        this.wrap = this.wraps.find((w) => w.value === "white");
        return;
      }
    },
    matOn: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("matOn watcher", value);
      // if the user turns off the mat, remove the selected mat
      if (!value || value === false) {
        this.mat = null;
        this.matSize = null;
        return;
      }

      if (value || value === true) {
        this.borderOn = false;
      }

      this.mat = this.mats.find((m) => m.value === "white");
      this.matSize = 2;

      setTimeout(() => {
        this.renderCanvas();
      }, 10);
    },
    frameOn: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("frameOn watcher", value);
      // if the user turns off the frame, remove the selected frame
      if (!value || value === false) {
        console.log("changing frame");
        this.frame = null;
        return;
      }

      this.frame = this.frames.find((m) => m.value === "black");

      const longEdge =
        this.printWidth > this.printHeight ? this.printWidth : this.printHeight;
      if (longEdge > 16) {
        this.plexi = true;
      }

      setTimeout(() => {
        this.renderCanvas();
      }, 10);
    },
    mat: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("mat watcher", value);
      this.resetUnavailableValues();
      // set a half inch border when a mat is selected
      if (value) {
        this.border = 0.5;
        if (this.media && this.media.value !== "canvas") {
          this.mountingOrStretcher = this.mountingsAndStretchers.find(
            (m) => m.value === "none"
          );
        }
      }

      setTimeout(() => {
        this.renderCanvas();
      }, 10);
    },
    matSize: function() {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      setTimeout(() => {
        console.log("matSize watcher");
        this.renderCanvas();
      }, 10);
    },
    printWidth: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("printWidth watcher", value);
      if (!value) {
        return;
      }

      console.log("image ratio", this.imageRatio);

      if (this.$route.query.mode === "calculator") {
        this.recalculateCanvasSize(
          this.getTotalDimension(value),
          this.totalHeight
        );
        return;
      }
      console.log("imageRatioHeight", this.imageRatioHeight);
      // since we're locked into an aspect ratio, set the height when the width is changed
      const newPrintHeight = this.roundImageDimension(
        parseFloat(parseFloat(value * this.imageRatioHeight).toFixed(2))
      );
      this.printHeight = newPrintHeight;
      console.log("setting the print height to", newPrintHeight);

      if (!this.printHeight) {
        return;
      }

      this.recalculateCanvasSize(
        this.getTotalDimension(value),
        this.totalHeight
      );
    },
    printHeight: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("printHeight watcher", value);
      if (!value) {
        return;
      }

      console.log("image ratio", this.imageRatio);

      if (this.$route.query.mode === "calculator") {
        this.recalculateCanvasSize(
          this.totalWidth,
          this.getTotalDimension(value)
        );
        return;
      }

      // this ratio is correct when the image has a longer height than width
      console.log("imageRatio", this.imageRatio);
      const newPrintWidth = this.roundImageDimension(
        parseFloat(parseFloat(value * this.imageRatio).toFixed(2))
      );

      // since we're locked into an aspect ratio, set the height when the height is changed
      this.printWidth = newPrintWidth;

      console.log("setting the print width to", newPrintWidth);

      if (!this.printWidth) {
        return;
      }

      this.recalculateCanvasSize(
        this.totalWidth,
        this.getTotalDimension(value)
      );
    },
    size: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("size watcher", value);
      // if the user changes the size, we might need to resize the canvas
      if (value && value.width && value.height) {
        // this.recalculateCanvasSize(value.width, value.height);
        console.log("size watch change stuff", value.width, value.height);

        this.printWidth = value.width;
        this.printHeight = value.height;
      } else {
        if (this.printSizes && this.printSizes.length > 2){
          let tmpSize = this.printSizes[this.printSizes.length - 2];
          this.printWidth = tmpSize.width;
          this.printHeight = tmpSize.height;
        }
      }

      this.sizeNone = false;

      // setTimeout(() => {
      //   this.renderCanvas();
      // }, 10);
    },
    canvasHeight: function() {
      setTimeout(() => {
        console.log("canvasHeight watcher");
        this.renderCanvas();
      }, 10);
    },
    // canvasElements: {
    //   handler() {
    //     console.log('rendering canvas from canvasElements watch', {
    //       ...this.canvasElements,
    //     });
    //     this.renderCanvas();
    //   },
    //   deep: true,
    // },
    wrap: function(value) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("wrap watcher", value);
      if (
        this.mountingOrStretcher === '½" stretcher' &&
        value === "White gallery wrap"
      ) {
        this.border = '2 ¼"';
      } else if (
        this.mountingOrStretcher === '½" stretcher' &&
        value === "Solid color gallery wrap"
      ) {
        this.border = '1 ¾"';
      } else if (
        this.mountingOrStretcher === '½" stretcher' &&
        value === "Mirror image gallery wrap"
      ) {
        this.border = '1 ¾"';
      } else if (
        this.mountingOrStretcher === '1" stretcher' &&
        value === "White gallery wrap"
      ) {
        this.border = '3 ¼"';
      } else if (
        this.mountingOrStretcher === '1" stretcher' &&
        value === "Solid color gallery wrap"
      ) {
        this.border = '2 ¼"';
      } else if (
        this.mountingOrStretcher === '1" stretcher' &&
        value === "Mirror image gallery wrap"
      ) {
        this.border = '2 ¼"';
      } else if (
        this.mountingOrStretcher === '1 ¼" stretcher' &&
        value === "White gallery wrap"
      ) {
        this.border = '3 ½"';
      } else if (
        this.mountingOrStretcher === '1 ¼" stretcher' &&
        value === "Solid color gallery wrap"
      ) {
        this.border = '2 ¼"';
      } else if (
        this.mountingOrStretcher === '1 ¼" stretcher' &&
        value === "Mirror image gallery wrap"
      ) {
        this.border = '2 ¼"';
      } else if (
        this.mountingOrStretcher === '2" stretcher' &&
        value === "White gallery wrap"
      ) {
        this.border = '3 ½"';
      } else if (
        this.mountingOrStretcher === '2" stretcher' &&
        value === "Solid color gallery wrap"
      ) {
        this.border = '2"';
      } else if (
        this.mountingOrStretcher === '2" stretcher' &&
        value === "Mirror image gallery wrap"
      ) {
        this.border = '2"';
      } else if (this.mountingOrStretcher === "Mount to Sintra") {
        this.border = '½"';
      } else if (this.mountingOrStretcher === "Mount to MDF") {
        this.border = '½"';
      } else if (this.mountingOrStretcher === "Mount to Foamcore") {
        this.border = '¼"';
      }

      setTimeout(() => {
        this.renderCanvas();
      }, 10);
    },
    mountingOrStretcher: function(newMountingOrStretcher) {
      // because something changed, we want to return to the preview
      this.returnToPreview();
      console.log("mountingOrStretcher watcher", newMountingOrStretcher);
      this.resetUnavailableValues();

      // if the mounting or stretcher was removed, make sure there is no wrap
      if (!newMountingOrStretcher) {
        this.wrap = null;
        return;
      }

      if (
        this.media &&
        this.media.value === "canvas" &&
        newMountingOrStretcher.stretcher &&
        !this.frameOn &&
        !this.wrap
      ) {
        this.wrap = this.wraps.find((w) => w.value === "none");
      }

      if (
        this.media &&
        this.media.value === "canvas" &&
        newMountingOrStretcher.stretcher &&
        this.frameOn &&
        this.frame
      ) {
        this.wrap = this.wraps.find((w) => w.value === "white");
      }
    },
  },
  filters: {
    currency: function(value) {
      if (!value) return "-";
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    },
  },
  computed: {
    ...mapGetters("cart", ["loading", "error", "cart"]),
    ...mapGetters("auth", ["authUser"]),
    subItems: function() {
      const items = [];
      if (!(this.media && this.media.value)) {
        return [];
      }

      if (this.media && this.media.value) {
        let border = this.borderOn ? this.border : 0;
        let item = {
          product: `media.${this.media.value}`,
          productVariant: this.media.value,
          quantity: this.quantity,
          description: border ? `${this.printWidth}x${
              this.printHeight
          }in. print of ${this.image.name ? this.image.name : "Untitled"}, with ${
              this.borderOn ? this.border : 0
          }in. border.` : '',
        };

        if (this.authUser) {
          item["description"] = `${this.printWidth}x${
            this.printHeight
          }in. print of ${this.image.name ? this.image.name : "Untitled"} by ${
            this.authUser.name
          } on ${this.media.text}, with ${
            this.borderOn ? this.border : 0
          }in. border.`;
        }

        if (
          this.media.value === "canvas" &&
          this.mountingOrStretcher &&
          this.mountingOrStretcher.additionalCanvas
        ) {
          item.amount =
            (this.printWidth + this.mountingOrStretcher.additionalCanvas) *
            (this.printHeight + this.mountingOrStretcher.additionalCanvas);
        } else {
          item.amount = this.frontSqIn;
        }

        item.unitPrice = this.media.pricePerSqIn;

        // TODO: depending on the stretcher there would be a different amount
        let inkPrice = 0;
        if (
          this.media.value === "canvas" &&
          this.wrap &&
          (this.wrap.value === "color" || this.wrap.value === "mirror")
        ) {
          let additionalInk = 1;
          if (
            this.mountingOrStretcher &&
            this.mountingOrStretcher.additionalInk
          ) {
            additionalInk = this.mountingOrStretcher.additionalInk;
          }
          inkPrice =
            (this.printWidth + additionalInk) *
            (this.printHeight + additionalInk) *
            this.pricing.inkPrice;
          // items.push(
          //   this.calculateItemTotals({
          //     product: 'wrap',
          //     productVariant: this.wrap.value,
          //     quantity: this.quantity,
          //     amount: this.imageSqIn,
          //     unitPrice: 0,
          //     description:
          //       this.wrap.value === 'color'
          //         ? `${this.wrap.value} wrap color ${this.wrapColor}`
          //         : `${this.wrap.value} wrap`,
          //     productTotal: 0,
          //   })
          // );
        } else {
          inkPrice = this.imageSqIn * this.pricing.inkPrice;
        }
        item.productTotal = this.round(item.unitPrice * item.amount + inkPrice);
        item.productBaseTotal = item.productTotal;
        item.productTotal = this.recalculateMarkup(item.productTotal, `media.${this.media.value}`);

        items.push(this.calculateItemTotals(item));
      }

      if (this.matOn && this.mat) {
        items.push(
          this.calculateItemTotals({
            product: "mat",
            productVariant: this.mat.value,
            quantity: this.quantity,
            amount: this.frontSqIn,
            unitPrice: this.mat.pricePerSqIn,
            description: `Image Size ${this.printWidth}x${this.printHeight}in. Matte Width ${this.matSize}in. Frame ${this.totalWidth}x${this.totalHeight}in.`,
            productTotal: this.round(
              (this.printWidth + this.matSize * 2) *
                (this.printHeight + this.matSize * 2) *
                this.mat.pricePerSqIn
            ),
          })
        );
      }

      if (this.frameOn && this.frame) {
        items.push(
          this.calculateItemTotals({
            product: "frame",
            productVariant: this.frame.value,
            quantity: this.quantity,
            amount: this.linearInches,
            unitPrice: this.frame.pricePerLinearIn,
            description: `CMI frame ${this.frame.text} ${this.frame.mouldingNumber} ${this.totalWidth}x${this.totalHeight}in.`,
            productTotal: this.round(
              this.linearInches * this.frame.pricePerLinearIn
            ),
          })
        );
      }

      if (this.media.value === "lustre" && !this.mat && this.frame) {
        items.push(
          this.calculateItemTotals({
            product: "spacers",
            productVariant: "spacers",
            quantity: this.quantity,
            description: `${this.linearInches} linear inches`,
            amount: this.linearInches,
            unitPrice: this.pricing.spacers,
            productTotal: this.round(this.linearInches * this.pricing.spacers),
          })
        );
      }

      if (this.varnish && this.varnish.pricePerSqIn) {
        items.push(
          this.calculateItemTotals({
            product: "varnish",
            productVariant: this.varnish.value,
            quantity: this.quantity,
            description: `${this.printWidth}x${this.printHeight}in. of ${this.varnish.text}`,
            amount: this.imageSqIn,
            unitPrice: this.varnish.pricePerSqIn,
            productTotal: this.recalculateMarkup(this.round(
              this.imageSqIn * this.varnish.pricePerSqIn
            ), 'varnish'),
            productBaseTotal: this.round(
                this.imageSqIn * this.varnish.pricePerSqIn
            ),
          })
        );
      }

      if (this.frame && this.media.options.glass) {
        items.push(
          this.calculateItemTotals({
            product: "foamcore",
            quantity: this.quantity,
            amount: this.linearInches,
            unitPrice: this.frame.pricePerLinearIn,
            description: `3/16 in. foam core`,
            productTotal: this.round(
              (this.printWidth + (this.matSize ? this.matSize : 0) * 2) *
                (this.printHeight + (this.matSize ? this.matSize : 0) * 2) *
                this.pricing.foamcore
            ),
          })
        );

        if (this.plexi) {

          console.log({
            printWidth: this.printWidth,
            matSize: this.matSize,
            printHeight: this.printHeight,
            pricingPlexi: this.pricing.plexi,
            productTotal: this.round(
                (this.printWidth + this.matSize * 2) *
                (this.printHeight + this.matSize * 2) *
                this.pricing.plexi
            ),
          }, 'plexi formula options');

          items.push(
            this.calculateItemTotals({
              product: "glass",
              productVariant: "plexi",
              quantity: this.quantity,
              amount: this.printHeight + this.printWidth,
              unitPrice: this.pricing.plexi,
              description: `${this.totalWidth}x${this.totalHeight}in. of plexi glass`,
              productTotal: this.round(
                (this.printWidth + this.matSize * 2) *
                  (this.printHeight + this.matSize * 2) *
                  this.pricing.plexi
              ),
            })
          );
        } else {
          items.push(
            this.calculateItemTotals({
              product: "glass",
              productVariant: "glass",
              quantity: this.quantity,
              amount: this.printHeight + this.printWidth,
              unitPrice: this.pricing.glass,
              description: `${this.totalWidth}x${this.totalHeight}in. of regular glass`,
              productTotal: this.round(
                (this.printWidth + this.matSize * 2) *
                  (this.printHeight + this.matSize * 2) *
                  this.pricing.glass
              ),
            })
          );
        }
      }

      if (this.mountingOrStretcher && this.mountingOrStretcher.pricePerSqIn) {
        if (this.mountingOrStretcher.stretcher) {Math.f
          let description = `${this.printWidth}x${this.printHeight}in. ${this.mountingOrStretcher.text}`;
          if (this.wrap) {
            description += ` with ${this.wrap.value} wrap`;
            if (this.wrap.value === "color") {
              description += ` of color ${this.wrapColor}`;
            }
          }
          items.push(
            this.calculateItemTotals({
              product: "stretcher",
              productVariant: this.mountingOrStretcher.value,
              quantity: this.quantity,
              amount: this.backSqIn,
              unitPrice: parseFloat(this.mountingOrStretcher.pricePerSqIn),
              description: description,
              productTotal: this.recalculateMarkup(this.round(
                this.linearInches * parseFloat(this.mountingOrStretcher.pricePerSqIn)
              ), 'stretcher'),
              productBaseTotal: this.round(
                  this.linearInches * parseFloat(this.mountingOrStretcher.pricePerSqIn)
              ),
            })
          );
        } else {
          items.push(
            this.calculateItemTotals({
              product: "mounting",
              productVariant: this.mountingOrStretcher.value,
              quantity: this.quantity,
              amount: this.backSqIn,
              unitPrice:
                this.pricing.mountingAdhesive +
                parseFloat(this.mountingOrStretcher.pricePerSqIn),
              description: `${this.printWidth}x${this.printHeight}in. of ${this.mountingOrStretcher.value}`,
              productTotal: this.recalculateMarkup(this.round(
                this.backSqIn *
                  (this.pricing.mountingAdhesive +
                    parseFloat(this.mountingOrStretcher.pricePerSqIn))
              ), 'mounting'),
              productBaseTotal: this.round(
                  this.backSqIn *
                  (this.pricing.mountingAdhesive +
                      parseFloat(this.mountingOrStretcher.pricePerSqIn))
              ),
            })
          );
        }
      }

      if (this.deckling) {
        let price = 5;
        if (this.frontSqIn > 320) {
          price = 10;
        }
        items.push(
          this.calculateItemTotals({
            product: "deckling",
            productVariant: "deckling",
            quantity: this.quantity,
            amount: this.deckling,
            unitPrice: price,
            description: `deckling`,
            productTotal: this.recalculateMarkup(this.round(price), 'deckling'),
            productBaseTotal: this.round(price),
          })
        );
      }

      // if (this.deckling) {
      //   if (this.frontSqIn < 320) {
      //     decklingPrice = 5;
      //   } else {
      //     decklingPrice = 10;
      //   }
      // }

      return items;
    },
    mountingOrStretcherLabel: function() {
      if (this.media && this.media.value === "canvas") {
        return "Mounting or Stretcher";
      }
      return "Mounting";
    },
    showOptionsCard: function() {
      if (!(this.size && this.printWidth && this.printHeight && this.media)) {
        return false;
      }
      if (this.media.value === "lustre") {
        return true;
      }
      if (this.media.value === "matte") {
        return true;
      }
      return true;
    },
    previewImages: function() {
      let images = [];

      if (this.media && this.media.previews) {
        // first get all of the images that don't have a "when", since they
        // will always be shown for this media
        const allImages = this.media.previews.filter((p) => !p.when);
        images = [...images, ...allImages];

        // next we will add images that match the criteria
        this.media.previews
          .filter((p) => p.when)
          .forEach((preview) => {
            if (
              preview.when.wrap &&
              this.wrap &&
              this.wrap.value === preview.when.wrap
            ) {
              images.push(preview);
            }

            if (preview.when.deckling && this.deckling) {
              images.push(preview);
            }

            if (preview.when.frameOn && this.frameOn) {
              images.push(preview);
            }

            if (
              preview.when.mountingOrStretcher &&
              this.mountingOrStretcher &&
              this.mountingOrStretcher.value ===
                preview.when.mountingOrStretcher
            ) {
              images.push(preview);
            }
          });
      }

      return images;
    },
    previewVideos: function() {
      const videos = [];

      if (this.frameOn && this.frame) {
        videos.push({
          description: `${this.frame.text} frame video preview.`,
          src: this.frame.previewVideo,
        });
      }

      return videos;
    },
    totalWidth: function() {
      return this.getTotalDimension(this.printWidth);
    },
    totalWidthForCanvas: function() {
      return this.getCanvasTotalDimension(this.printWidth);
    },
    totalHeight: function() {
      return this.getTotalDimension(this.printHeight);
    },
    validationRules: function() {
      const rules = {};

      rules.required = [(v) => !!v || "This field is required."];

      if (this.borderOn) {
        rules.border = [
          (v) =>
            (v > 0 && v <= 6) || "The border must be between 1 and 6 inches.",
        ];
      }

      rules.matSize = [
        (v) => (v > 0 && v <= 6) || "The mat must be between 1 and 6 inches.",
      ];

      rules.printWidth = [];
      rules.printHeight = [];
      rules.size = [];
      rules.wrap = [];

      if (
        this.media &&
        this.media.value === "canvas" &&
        this.mountingOrStretcher &&
        this.mountingOrStretcher.stretcher
      ) {
        rules.wrap.push(
          (v) => !!v || "A wrap is required with a stretched canvas."
        );
      }

      if (this.size && this.size.value === "custom") {
        rules.printWidth.push(
          (v) => !!v || "This field is required when using a custom size."
        );
        rules.printHeight.push(
          (v) => !!v || "This field is required when using a custom size."
        );
      }

      // check max size based on media choice
      if (this.media && this.media.maxDimensions) {
        // check to make sure that the image is not outside of the max dimensions
        rules.printWidth.push(
          () =>
            !this.overSize ||
            `Selected size is too large for the selected media. Maximum print size for the selected media is ${this.media.maxDimensions[0]} in x ${this.media.maxDimensions[1]} in.`
        );
      }

      return rules;
    },
    imageRatio: function() {
      if (!this.canvasImage) {
        return null;
      }

      return this.canvasImage.width / this.canvasImage.height;
    },
    imageRatioHeight: function() {
      if (!this.canvasImage) {
        return null;
      }

      return this.canvasImage.height / this.canvasImage.width;
    },
    imageLongSide: function() {
      if (!this.canvasImage) {
        return null;
      }

      if (this.canvasImage.height >= this.canvasImage.width) {
        return "height";
      }

      return "width";
    },
    printSizes: function() {
      const sizes = [];
      // determine the proportional sizes based on the aspect ratio
      if (this.canvasImage) {
        this.printSizesLongEdge.forEach((longEdge) => {
          if (this.imageLongSide === "height") {
            const height = longEdge;
            const width = this.roundImageDimension(
              parseFloat(parseFloat(longEdge * this.imageRatio).toFixed(2))
            );
            const text = `${width} x ${height}in`;
            const value = `${width}-${height}`;

            sizes.push({
              text: text,
              value: value,
              width: width,
              height: height,
            });
          } else {
            const width = longEdge;
            const height = this.roundImageDimension(
              parseFloat(
                parseFloat(longEdge * this.imageRatioHeight).toFixed(2)
              )
            );
            const text = `${width} x ${height}in`;
            const value = `${width}-${height}`;

            sizes.push({
              text: text,
              value: value,
              width: width,
              height: height,
            });
          }
        });
      }

      sizes.push({ text: "Custom", value: "custom" });
      sizes.unshift({ text: "None", value: "none" });
      return sizes;
    },
    overSize: function() {
      // check if either the width or the height is larger than the allowed
      // dimensions

      // if all of our dependencies are here
      if (
        this.printWidth &&
        this.printHeight &&
        this.media &&
        this.media.maxDimensions[0] &&
        this.media.maxDimensions[1]
      ) {
        const widthLargerThanOneSide =
          this.printWidth > this.media.maxDimensions[0] ||
          this.printWidth > this.media.maxDimensions[1];
        const widthLargerThanBothSides =
          this.printWidth > this.media.maxDimensions[0] &&
          this.printWidth > this.media.maxDimensions[1];
        const heightLargerThanOneSide =
          this.printHeight > this.media.maxDimensions[0] ||
          this.printHeight > this.media.maxDimensions[1];
        const heightLargerThanBothSides =
          this.printHeight > this.media.maxDimensions[0] &&
          this.printHeight > this.media.maxDimensions[1];

        console.log(
          widthLargerThanOneSide,
          widthLargerThanBothSides,
          heightLargerThanOneSide,
          heightLargerThanBothSides
        );
        // check if any of the sizes are larger than the allowed sizes
        // if the width is larger than one side, but not the other AND the height
        // isn't larger than

        if (widthLargerThanOneSide && heightLargerThanOneSide) {
          return true;
        }

        if (widthLargerThanBothSides || heightLargerThanBothSides) {
          return true;
        }
      }
      return false;
    },
    mountingOrStretcherRequired: function() {
      const hasNoMountingOrStretcher =
        !this.mountOrStretcher ||
        (this.mountingOrStretcher && this.mountingOrStretcher.value === "none");

      if (
        this.media &&
        this.media.value === "canvas" &&
        hasNoMountingOrStretcher
      ) {
        return true;
      }

      return false;
    },
    formMessages: function() {
      const messages = {};

      messages.frame = this.frameMessage;

      messages.plexi = this.plexiMessage;

      messages.wrap = this.wrapMessage;

      return messages;
    },
    innerFrameWidth: function() {
      if (!(this.printWidth && this.printHeight)) {
        return null;
      }
      if (this.matOn && this.matSize) {
        console.log("innerFrameWidth", this.printWidth, this.matSize);
        return this.printWidth + this.matSize * 2;
      }
      return this.printWidth;
    },
    innerFrameHeight: function() {
      if (!(this.printWidth && this.printHeight)) {
        return null;
      }
      console.log("innerFrameHeight", this.printHeight, this.matSize);
      if (this.matOn && this.matSize) {
        return this.printHeight + this.matSize * 2;
      }
      return this.printHeight;
    },
    wrapMessage: function() {
      if (this.media && this.frame) {
        return "A white wrap is used with a frame.";
      }

      return null;
    },
    frameDisabled: function() {
      if (this.longEdge > 32) {
        return true;
      }

      return false;
    },
    frameMessage: function() {
      if (!this.frameDisabled) {
        return null;
      }
      return 'Frames are disabled for prints over 32".';
    },
    plexiRequired: function() {
      // there is no plexi for canvas frames
      if (this.media && this.media.value === "canvas") {
        return false;
      }

      if (this.longEdge > 16) {
        return true;
      }

      return false;
    },
    longEdge: function() {
      if (!(this.printWidth && this.printHeight)) {
        return null;
      }

      return this.printWidth > this.printHeight
        ? this.printWidth
        : this.printHeight;
    },
    linearInches: function() {
      if (!(this.printWidth && this.printHeight)) {
        return null;
      }
      if (this.matOn && this.matSize) {
        return (
          (this.printHeight + this.matSize) * 2 +
          (this.printWidth + this.matSize) * 2
        );
      }
      return this.printHeight * 2 + this.printWidth * 2;
    },
    canvasPixelsPerInch: function() {
      // determine the scale between the image size and canvas width
      // relative to pixels
      let width = 20;
      //   let height = 30;
      if (this.totalWidth) {
        // width = this.totalWidth;
        width = this.totalWidthForCanvas;
      }

      return this.getCanvasPixelsPerInch(width);
    },
    imageSqIn: function() {
      if (!(this.printWidth && this.printHeight)) {
        return null;
      }
      // border calculation
      let borderSize = 0;
      if (this.borderOn && this.border) {
        borderSize = this.border;
      }
      return this.round(
        (this.printHeight + borderSize * 2) * (this.printWidth + borderSize * 2)
      );
    },
    frontSqIn: function() {
      if (!(this.totalWidth && this.totalHeight)) {
        return null;
      }
      return this.round(this.totalWidth * this.totalHeight);
    },
    backSqIn: function() {
      if (!(this.totalWidth && this.totalHeight)) {
        return null;
      }
      return this.round(this.totalWidth * this.totalHeight);
    },
    discountTotalOld: function() {
      if (!this.size) {
        return null;
      }
      return this.subItems.reduce((total, item) => {
        return total + item.discountTotalOld * item.quantity;
      }, 0);
    },
    discountTotal: function() {
      if (!this.size) {
        return null;
      }
      return this.subItems.reduce((total, item) => {
        return total + item.discountTotal * item.quantity;
      }, 0);
    },
    pricePerOld: function() {
      if (!(this.printWidth && this.printHeight) || !this.media) {
        return null;
      }
      if (!this.frontSqIn) {
        return null;
      }
      return this.subItems.reduce((total, item) => {
        return total + item.productBaseTotal;
      }, 0);
    },
    pricePer: function() {
      if (!(this.printWidth && this.printHeight) || !this.media) {
        return null;
      }
      if (!this.frontSqIn) {
        return null;
      }
      return this.subItems.reduce((total, item) => {
        return total + item.productTotal;
      }, 0);
    },
    productTotalOld: function() {
      if (!this.size) {
        return null;
      }
      const total = this.quantity * this.pricePerOld;
      return total;
    },
    productTotal: function() {
      if (!this.size) {
        return null;
      }
      const total = this.quantity * this.pricePer;
      return total;
    },
    totalPrice: function() {
      if (!this.size) {
        return null;
      }

      console.log(this.subItems, 'this.subItems');

      return this.subItems.reduce((total, item) => {
        return total + item.total;
      }, 0);
    },
    totalPriceOld: function() {
      if (!this.size) {
        return null;
      }

      return this.subItems.reduce((total, item) => {
        return total + item.totalOld;
      }, 0);
    },
    options: function() {
      if (!this.media) {
        return {};
      }

      // generate the options
      const options = {};

      for (const [key, value] of Object.entries(this.media.options)) {
        if (Array.isArray(value)) {
          options[key] = value.map((v) =>
            this[key].find((item) => v === item.value)
          );
        } else {
          options[key] = value;
        }
      }

      // modify the options as needed

      // if the user has chosen a frame, they can only use the white wrap option
      // there is no need for a color or mirror wrap since it will be covered by
      // the frame
      if (this.frameOn && this.frame && options.wraps) {
        options.wraps = options.wraps.filter((w) => w.value === "white");
      }

      if (
        this.media.value === "canvas" &&
        this.frameOn &&
        this.frame &&
        options.mountingsAndStretchers
      ) {
        options.mountingsAndStretchers = this.mountingsAndStretchers.filter(
          (s) => {
            return (
              s.value === "mdf" || s.value === "sintra" || s.value === "one"
            );
          }
        );
      }

      // don't allow a user to select a mounting or stretcher with matte paper and a mat
      if (this.media.value === "matte" && this.matOn && this.mat) {
        options.mountingsAndStretchers = false;
      }

      // only allow border on canvas when not mounting
      if (
        this.media.value === "canvas" &&
        this.mountingOrStretcher &&
        this.mountingOrStretcher.value === "none"
      ) {
        options.border = true;
      }

      return options;
    },
    wrapDisabled: function() {
      return this.mountingOrStretcherRequired;
    },
    borderHidden: function() {
      if (this.mat) {
        return true;
      }

      if (this.frameOn && this.frame) {
        return true;
      }

      return false;
    },
    requiredBorderSize: function() {
      if (
        this.mountingOrStretcher === '½" stretcher' &&
        this.wrap === "White gallery wrap"
      ) {
        return '2 ¼"';
      } else if (
        this.mountingOrStretcher === '½" stretcher' &&
        this.wrap === "Solid color gallery wrap"
      ) {
        return '1 ¾"';
      } else if (
        this.mountingOrStretcher === '½" stretcher' &&
        this.wrap === "Mirror image gallery wrap"
      ) {
        return '1 ¾"';
      } else if (
        this.mountingOrStretcher === '1" stretcher' &&
        this.wrap === "White gallery wrap"
      ) {
        return '3 ¼"';
      } else if (
        this.mountingOrStretcher === '1" stretcher' &&
        this.wrap === "Solid color gallery wrap"
      ) {
        return '2 ¼"';
      } else if (
        this.mountingOrStretcher === '1" stretcher' &&
        this.wrap === "Mirror image gallery wrap"
      ) {
        return '2 ¼"';
      } else if (
        this.mountingOrStretcher === '1 ¼" stretcher' &&
        this.wrap === "White gallery wrap"
      ) {
        return '3 ½"';
      } else if (
        this.mountingOrStretcher === '1 ¼" stretcher' &&
        this.wrap === "Solid color gallery wrap"
      ) {
        return '2 ¼"';
      } else if (
        this.mountingOrStretcher === '1 ¼" stretcher' &&
        this.wrap === "Mirror image gallery wrap"
      ) {
        return '2 ¼"';
      } else if (
        this.mountingOrStretcher === '2" stretcher' &&
        this.wrap === "White gallery wrap"
      ) {
        return '3 ½"';
      } else if (
        this.mountingOrStretcher === '2" stretcher' &&
        this.wrap === "Solid color gallery wrap"
      ) {
        return '2"';
      } else if (
        this.mountingOrStretcher === '2" stretcher' &&
        this.wrap === "Mirror image gallery wrap"
      ) {
        return '2"';
      } else if (this.mountingOrStretcher === "Mount to Sintra") {
        return '½"';
      } else if (this.mountingOrStretcher === "Mount to MDF") {
        return '½"';
      } else if (this.mountingOrStretcher === "Mount to Foamcore") {
        return '¼"';
      }

      return null;
    },
    wrapRequired: function() {
      return (
        this.mountingOrStretcher && this.mountingOrStretcher.stretcher === true
      );
    },
    plexiMessage: function() {
      if (!this.plexiRequired) {
        return null;
      }

      return 'Plexi is used for prints over 16".';
    },
  },
  created: async function() {
    if (this.authUser) {
      await this.$store.dispatch("auth/getAuthUser");
    }
  },
  mounted: async function() {
    this.initialLoading = true;
    // if there is no id, we can't do anything so we're going to
    if (
      !(this.$route.query.image_id || this.$route.query.cart_item_id) &&
      this.$route.query.mode !== "calculator"
    ) {
      this.$router.push("/my-account");
    }

    // load all the config
    this.frames = await ConfigService.getFrames();
    this.mats = await ConfigService.getMats();
    this.medias = await ConfigService.getMedias();
    this.mountingsAndStretchers = await ConfigService.getMountings();
    this.presets = await ConfigService.getPresets();
    this.pricing = await ConfigService.getPricing();
    this.printSizesLongEdge = await ConfigService.getPrintSizes();
    this.varnishes = await ConfigService.getVarnishes();
    this.wraps = await ConfigService.getWraps();

    let imageData;
    if (this.$route.query.mode === "create") {
      try {
        this.previewImagePreset = await ImageService.previewImagePreset(this.$route.query.image_id, 600);
        this.originalImagePreset = await ImageService.previewImagePreset(this.$route.query.image_id, 1200);

        const imageObject = await ImageService.getImage(
          this.$route.query.image_id
        );
        this.image = imageObject;
        imageData = await ImageService.getImageData(this.$route.query.image_id);

        this.initialLoading = false;
      } catch (err) {
        console.error(err);
        this.$store.dispatch("snackbar/showSnack", {
          text: "There was an error loading image data.",
          color: "error",
          timeout: 3500,
        });
        this.$router.push("/my-account");
      }
    } else if (this.$route.query.mode === "edit") {
      try {
        // load up all of the data and information needed
        let cartItem = "";
        const imageQueryId = this.$route.query.cart_item_id;

        if (this.authUser) {
          cartItem = await CartService.getCartItem(
            this.$route.query.cart_item_id
          );
        } else {
          let localData = JSON.parse(localStorage.getItem("guestCart") || "[]");
          let localItems = localData.cart_items;
          console.log(localItems);

          cartItem = localItems.filter(function(obj) {
            return obj.local_id == imageQueryId;
          })[0];
        }
        this.cart_item = cartItem;
        this.quantity = cartItem.quantity;
        console.log(cartItem);
        const imageObject = await ImageService.getImage(cartItem.image_id);
        this.image = imageObject;
        imageData = await ImageService.getImageData(cartItem.image_id);

        // set the state from the cart
        console.log(cartItem);
        const state = cartItem.print_options;

        if (state.media) {
          this.media = this.medias.find((m) => m.value === state.media);
        }

        setTimeout(() => {
          this.preset = {
            name: "Custom",
            previewImage: "./images/products/Custom.jpg",
            description: "Create a completely custom piece.",
            custom: true,
            config: {
              size: "custom",
            },
          };
          if (state.size) {
            this.size = this.printSizes.find((s) => s.value === state.size);
          }

          if (state.printWidth && state.printHeight) {
            this.printWidth = state.printWidth;
            this.printHeight = state.printHeight;
            this.size = this.printSizes.find((s) => s.value === "custom");
          }

          if (state.frame) {
            this.frame = this.frames.find((f) => f.value === state.frame);
            this.frameOn = true;
          }
          if (state.mountingOrStretcher) {
            this.mountingOrStretcher = this.mountingsAndStretchers.find(
              (m) => m.value === state.mountingOrStretcher
            );
          }

          if (state.mat) {
            this.mat = this.mats.find((m) => m.value === state.mat);
            this.matOn = true;
            if (state.matSize) {
              this.matSize = state.matSize;
            } else {
              this.matSize = 2;
            }
          }

          if (state.border) {
            this.border = state.border;
            this.borderOn = true;
          }

          if (state.varnish) {
            this.varnish = this.varnishes.find(
              (v) => v.value === state.varnish
            );
          }

          if (state.wrap) {
            this.wrap = this.wraps.find((w) => w.value === state.wrap);
          }

          if (state.deckling) {
            this.deckling = state.deckling;
          }
          this.initialLoading = false;
        }, 10);
      } catch (err) {
        console.error(err);
        this.$store.dispatch("snackbar/showSnack", {
          text: "There was an error loading image data.",
          color: "error",
          timeout: 3500,
        });
        this.$router.push("/my-account");
      }
    } else if (this.$route.query.mode === "calculator") {
      try {
        const imageObject = {
          id: 38,
          name: "Calculator Image",
          original_width: null,
          original_height: null,
          proof_pixel_height: 8900,
          proof_pixel_width: 12242,
          created_at: "07/13/2021",
          updated_at: "03/09/2022",
          available_dimensions: [
            {
              text: "1920 x 1396px",
              value: "1920-1396",
              width: 1920,
              height: 1396,
              unit: "px",
            },
            {
              text: "1080 x 785px",
              value: "1080-785",
              width: 1080,
              height: 785,
              unit: "px",
            },
            {
              text: "8 x 5.82in",
              value: "8-5.82",
              width: 8,
              height: 5.82,
              unit: "in",
            },
            {
              text: "10 x 7.27in",
              value: "10-7.27",
              width: 10,
              height: 7.27,
              unit: "in",
            },
          ],
          ratio: 1.375505617977528,
          height_ratio: 0.7270053912759353,
          long_side: "width",
          date_scanned: "07/09/2021",
          thumbnail_image: {
            id: 75,
            type: "thumbnail",
            path:
              "http://localhost/storage/images/f5cf5ca32b8ae9402e27a8c7a50042e3.jpg",
            created_at: "2021-07-13T19:02:12.000000Z",
            updated_at: "2021-07-13T19:02:12.000000Z",
          },
          preview_image: {
            id: 76,
            type: "preview",
            path:
              "http://localhost/storage/images/00a479750b6d58bffbabb54425d1a18b.jpg",
            created_at: "2021-07-13T19:02:16.000000Z",
            updated_at: "2021-07-13T19:02:16.000000Z",
          },
        };
        this.image = imageObject;
        // imageData = calculatorImageData;
        this.initialLoading = false;
        // const preset = this.presets.find((preset) => preset.name === 'Custom');
        // this.selectPreset(preset);
      } catch (err) {
        console.error(err);
        // this.$store.dispatch('snackbar/showSnack', {
        //   text: 'There was an error loading image data.',
        //   color: 'error',
        //   timeout: 3500,
        // });
        // this.$router.push('/gallery');
      }
    } else {
      console.log("redirecting to gallery");
      this.$router.push("/my-account");
    }
    const ref = this.$refs.imageCanvas;
    const canvas = ref.getContext("2d");

    this.$store.dispatch("loader/showLoader", {
      loading: false,
    });

    this.canvas = canvas;
    const image = new Image();
    imageData
      ? (image.src = imageData.data)
      : (image.src = "/images/placehold.webp");
    console.log(image);
    // image.onload = async function() {
    const vibrant = new Vibrant(image);
    const palette = await vibrant.getPalette();
    console.log(palette);
    this.canvasImage = image;
    const imageScale = this.canvasWidth / image.width;
    const height = image.height * imageScale;
    this.canvasHeight = height;

    //   const scaleX = this.canvasWidth / image.width;
    // const scaleY = this.canvasHeight / image.height;
    // console.log(scaleX, scaleY);

    this.imagePallete = palette;
    // Vue.set('imagePallete', palette);
    const swatches = [];
    for (const key in palette) {
      swatches.push([palette[key].getHex()]);
    }
    console.log(swatches);
    this.imageSwatches = swatches;
    setTimeout(() => {
      this.renderCanvas();
    }, 10);
    // };
    // image.onload = async function() {
    //   const fabricImage = new fabric.Image(image);
    //   canvas.setBackgroundImage(fabricImage);
    //   canvas.renderAll();

    //   const vibrant = new Vibrant(image);
    //   const palette = await vibrant.getPalette();
    //   console.log(palette);

    //   this.imagePallete = palette;
    //   Vue.set('imagePallete', palette);
    //   const swatches = [];
    //   for (const key in palette) {
    //     swatches.push(palette[key].getHex());
    //   }
    //   console.log(swatches);
    //   this.imageSwatches = swatches;
    //   Vue.set('imageSwatches', swatches);
    // };

    // const scaleX = this.canvasWidth / image.width;
    // const scaleY = this.canvasHeight / image.height;
    // console.log(scaleX, scaleY);
    // this.canvas.drawImage(image, 0, 0, this.canvasWidth, this.canvasHeight);
    // // set the background canvas element
    // this.canvasElements.background = image;
    // const fabricImage = new fabric.Image(image);
    // // canvas.setBackgroundImage(fabricImage, canvas.renderAll.bind(canvas), {
    // //
    // // });
    // canvas.add(fabricImage, canvas.renderAll.bind(canvas), {
    //   scaleX: canvas.width / fabricImage.width,
    //   scaleY: canvas.height / fabricImage.height,
    // });

    // canvas.renderAll();

    if (this.image.ImageCategory && this.image.ImageCategory.id) {
      try {
        const sliderCategory = await ImageService.getImageCategory(
          this.image.ImageCategory.id
        );
        this.sliderCategory = sliderCategory;
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>

<style lang="scss">
.v-window-item {
  opacity: 1 !important;
  visibility: visible !important;
}
.preview-image-preset-inner-wrap {
  text-align: center;
}
.preview-image-preset-wrap {
  display: block;
  border: 15px solid #131313;
  margin-bottom: 20px;
  border-radius: 10px;
}
.preview-image-preset-inner-wrap .preview-image-preset-img {
  border: 15px solid #D9DCD6;
}
.preview-image-preset-title {
  text-align: center;
  margin-bottom: 10px;
}
.preview-image-preset-artist-link {
  color:var(--red) !important;
  font-weight: bold;
}

@import "./style-order.scss";
</style>
